import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

import * as SubframeCore from '@subframe/core';

export const twClassNames = SubframeCore.createTwClassNames([
  'text-caption',
  'text-caption-bold',
  'text-body',
  'text-body-bold',
  'text-heading-3',
  'text-heading-2',
  'text-heading-1',
  'text-monospace-body',
]);
